import app from 'flarum/forum/app';
import { extend } from 'flarum/common/extend';
import IndexPage from 'flarum/forum/components/IndexPage';
import LinkButton from 'flarum/common/components/LinkButton';
import CoursePage from './components/CoursePage';

app.initializers.add('taro-course', () => {
  app.routes['courses'] = { path: '/courses', component: CoursePage };

  extend(IndexPage.prototype, 'navItems', function (items) {
    items.add(
      'courses',
      <LinkButton href={app.route('courses')} icon="fas fa-book-open">
        新手启迪
      </LinkButton>,
      80
    );
  });
});
